import StoresController from './stores-controller'

export default StoresController
